import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { LedgerStatus } from "./LedgerService";

class ItemCategoryService {
  private route = "/V1/API/Billing/Acc_ItemCategories";

  getCategoryList = (
    companyId: string | undefined,
    start: number = 0,
    length: number = 0,
    search?: string,
    sortCol?: number,
    sortDir?: number,
    LedgerStatus?: LedgerStatus
  ) =>
    // ApiUtility.get(
    //   `${this.route}/${companyId}/GetList?sortCol=${sortCol}&sortDir=${sortDir}&search=${search}`
    // );
    ApiUtility.get(`${this.route}/${companyId}/GetList`, {
      start,
      length,
      search,
      sortCol,
      sortDir,
    });

  getCategoryDatabyId = (companyId: string | undefined, categoryId: string) =>
    ApiUtility.get(`${this.route}/${companyId}/${categoryId}`);

  deleteCategoryDatabyId = (
    companyId: string | undefined,
    categoryId: string
  ) => ApiUtility.delete(`${this.route}/${companyId}/${categoryId}`);

  postCategoryData = (
    companyId: string | undefined,
    categoryId: string,
    modal: any
  ) =>
    ApiUtility.post(
      `${this.route}/${companyId}/${categoryId ? categoryId : ""}`,
      modal
    );
}
export default new ItemCategoryService();
